import React from 'react';
import { Switch } from '@headlessui/react';
import { BarChart } from 'lucide-react';

interface ChartToggleProps {
  showSecondaryAxis: boolean;
  onToggle: (value: boolean) => void;
  label?: string;
}

export function ChartToggle({ showSecondaryAxis, onToggle, label = "Show Secondary Axis" }: ChartToggleProps) {
  return (
    <Switch.Group>
      <div className="flex items-center gap-2">
        <Switch.Label className="text-sm text-gray-600">
          <BarChart size={16} className="inline mr-1" />
          {label}
        </Switch.Label>
        <Switch
          checked={showSecondaryAxis}
          onChange={onToggle}
          className={`${
            showSecondaryAxis ? 'bg-blue-600' : 'bg-gray-200'
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
        >
          <span
            className={`${
              showSecondaryAxis ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
}